import { useEffect } from 'react';
import App from './app';

import { mixpanel } from '@global/monitoring/mixpanel/index';

// eslint-disable-next-line prettier/prettier
const Wallet = ({ commonRoutes }: { commonRoutes: React.ReactNode }) => {
  useEffect(() => {
    mixpanel.register({
      version: '3.0',
      application: '3.0'
    });
  }, []);

  return <App commonRoutes={commonRoutes} />;
};
export default Wallet;
